import React, { CSSProperties } from "react"
import { MobergFontFamily, MobergFontSize } from "../MobergFont/MobergFont"

type MobergTextProps = {
    fontSize?: MobergFontSize
    fontFamily?: MobergFontFamily
    fontWeight?: string
    style?: CSSProperties
}

export const MobergText: React.FC<MobergTextProps> = ({ fontSize=MobergFontSize.REGULAR, fontFamily=MobergFontFamily.REGULAR, fontWeight="regular", style, children }) => {
    return (
        <span style={{ fontSize, fontFamily, fontWeight, color: "var(--text-color)", ...style }}>
            {children}
        </span>
    )
}

export const MobergHeader: React.FC<MobergTextProps> = ({ fontSize=MobergFontSize.X_LARGE, fontFamily=MobergFontFamily.HEADER, fontWeight="bold", style, children }) => {
    return (
        <span style={{ fontSize, fontFamily, fontWeight, color: "var(--text-color)", ...style }}>
            {children}
        </span>
    )
}
